// extracted by mini-css-extract-plugin
export default {"tag-container":"KEuLcE"};